module.exports = __webpack_public_path__ + "img/trip-cancelation_0.cde5811a.jpg";